import { CSSProperties } from "react";
import { Button } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

export const FormAddInvoices = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  align-items: right;
  margin-top: 0;
  position: relative;

  &.disabled {
    grid-template-columns: 1fr;
  }
  .ant-input-affix-wrapper-disabled {
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@avatar-background"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@avatar-background"]} !important;
        border: none !important;
        :hover {
          background-color: ${(props) => props.theme["@avatar-background"]} !important;
          border: none !important;
        }
      }
    }
  }

  div {
    .ant-form-item-control-input-content {
      position: relative;
      width: 100%;
    }
  }

  input {
    margin: 0 20px;
  }

  .ant-form-item-label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 600;
    padding: 0;
  }

  .ant-form-item-control-input-content {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const AddButtonInvoice = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  float: left;
  display: flex;
  justify-content: center;
  margin-top: 10px !important;
  color: ${(props) => props.theme.colors.text};
  :hover,
  :focus {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .addButtonInvoices {
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const RemoveButtonInvoice = styled(Button)`
  outline: none;
  border: none;
  box-shadow: none;
  margin-top: 8px !important;
  color: ${(props) => props.theme.colors.text};
  :hover,
  :focus {
    color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .removeButtonInvoices {
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
`;

export const InvoicesField: CSSProperties = {
  width: "100%",
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
  margin: 0,
  color: theme["@default-color"],
  fontFamily: theme["@font-family"],
};

export const InvoicesFieldIcon: CSSProperties = {
  marginLeft: "0",
};

export const InvoicesFieldIconAdd: CSSProperties = {
  marginTop: "2px",
  marginLeft: "0",
};

export const FieldContainer = styled.div`
  display: flex;
  align-items: center;
`;
